export function ensureStream(source) {
    if (source.stream) {
        return source;
    }
    const stream = () => {
        return new ReadableStream({
            start(controller) {
                void source.arrayBuffer().then((arrayBuffer) => {
                    controller.enqueue(arrayBuffer);
                    controller.close();
                });
            },
        });
    };
    return {
        ...source,
        stream,
    };
}
//# sourceMappingURL=ensureStream.js.map